import createSetItemField from './utils/createSetItemField';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function createRequestBody(itemIds, flagStatus) {
    var update = createSetItemField('Flag', { FlagStatus: flagStatus });
    var itemChanges = [];
    itemIds.forEach(function (id) {
        return itemChanges.push(itemChange({
            Updates: [update],
            ItemId: itemId({ Id: id }),
        }));
    });
    return updateItemRequest({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
export default function flagItemService(itemIds, flagStatus) {
    var requestBody = createRequestBody(itemIds, flagStatus);
    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=flagItemService.js.map